<form [formGroup]="form" *ngIf="coberturasCatalogo && coberturasCatalogo.length > 0">
    <ng-container *ngFor="let cob of coberturasCatalogo">
        <div class="row col-12">
            <ca-checkbox 
                [formControlName]="'cob_' + (cob.idCobertura)">
                {{ cob.descCobertura }}
            </ca-checkbox>
        </div>
    </ng-container>
</form>